<template>
  <ax-dialog 
    ref="dialog"
    title="Aggregate Summary" 
    icon="mdi-select-compare" 
    tooltip="Aggregate Summary" 
    size="large"
    persistent
    @submitted="onSubmit"
    @shown="onShown"
  >
    <template slot="content">
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Method</th>
                <th colspan="3" class="text-center" v-for="method in methods">{{ method.toUpperCase() }}</th>
              </tr>
              <tr>
                <th>Technique</th>
                <template v-for="_ in methods">
                  <th>P10</th>
                  <th>P50</th>
                  <th>P90</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="technique in techniques">
                <th>{{ technique.toUpperCase() }}</th>
                <template v-for="method in methods">
                  <td>
                    {{ statistics[method][technique]['mean'] | numberFormat((round = true)) }}
                  </td>
                  <td>
                    {{ statistics[method][technique]['p50'] | numberFormat((round = true)) }}
                  </td>
                  <td>
                    {{ statistics[method][technique]['p90'] | numberFormat((round = true)) }}
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </template>
    <template slot="submit_text"> Close </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
import Forecasting from "@/api/forecasting"
export default {
  name: "dlgWellComparison",
  props: {
    item: { type: Object, required: true },
    wells: { type: Array, default: () => [] },
    group: { type: Object, default: () => {} },
    payload: { type: Object, default: () => {} },
  },
  components: {
    AxDialog
  },
  data() {
    return {
      methods: [],
      techniques: [],
      aggregates: {
        selected: 'p50',
        options: ['mean','p1','p10','p50','p90','p99']
      },
      statistics: {}
    }
  },
  mounted() {
    if (!!this.item) {
      this.methods = this.item.methods.map(x => x.slug)
      this.techniques = this.item.config.techniques
    }
  },
  computed: {
    
  },
  methods: {
    onShown(val) {
      if (val) {
        this.methods.forEach(method => {
          this.$set(this.statistics, method, {})
          this.techniques.forEach(technique => {
            this.$set(this.statistics[method], technique, {})
            const payload = this.payload
            payload['settings']['method'] = method
            payload['settings']['technique'] = technique
            Forecasting.get_statistics(this.item.uuid, this.payload).then(response => {
              this.statistics[method][technique] = response.data[0]
            })
          })
        })
      }
    },
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted')
    }
  }
}
</script>